import { useInView } from "react-intersection-observer"
import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import landscape1200w from "images/homepage-hero-tvc-landscape-1200w.jpg"
import landscape2400w from "images/homepage-hero-tvc-landscape-2400w.jpg"
import portrait1080w from "images/homepage-hero-tvc-portrait-1080w.jpg"
import portrait540w from "images/homepage-hero-tvc-portrait-540w.jpg"
import ScrollCta from "../ScrollCta"
import SplashCtaDropdown from "../SplashCtaDropdown"
import Typewriter from "typewriter-effect"

const SplashHeroTypewriter: React.FC = () => {
  const [ref, inView] = useInView({ threshold: 0 })
  return (
    <section className={styles.splashHeroTypewriter} ref={ref}>
      <picture className={styles.picture}>
        <source
          media="(orientation: landscape)"
          srcSet={`${landscape2400w} 2400w, ${landscape1200w} 1200w`}
          sizes="100vw"
        />
        <source
          media="(orientation: portrait)"
          srcSet={`${portrait1080w} 1080w, ${portrait540w} 540w`}
          sizes="100vw"
        />
        <img
          className={cx({
            [styles.image]: true,
            [styles.inView]: inView,
          })}
          src={portrait540w}
          alt="Better House"
        />
      </picture>
      <div className={styles.pagePadding}>
        <div className={styles.message}>
          <h1 className={styles.heading}>
            <span
              className={cx({
                [styles.better]: true,
                [styles.paddingLg]: true,
              })}
            >
              Better
            </span>
            {inView && (
              <Typewriter
                options={{
                  speed: 50,
                  cursor: "_",
                  loop: false,
                  autoStart: false,
                }}
                className={styles.typewriter}
                onInit={(typewriter) => {
                  typewriter
                    .changeDelay(50)
                    .changeDeleteSpeed(3)
                    .typeString("guidance")
                    .pauseFor(500)
                    .deleteChars(8)
                    .pauseFor(50)
                    .typeString("options")
                    .pauseFor(500)
                    .deleteChars(7)
                    .pauseFor(50)
                    .typeString("tools")
                    .pauseFor(500)
                    .deleteChars(5)
                    .pauseFor(50)
                    .typeString("advice")
                    .pauseFor(500)
                    .deleteChars(6)
                    .pauseFor(50)
                    .typeString("Mortgage")
                    .pauseFor(2000)
                    .deleteChars(8)
                    .pauseFor(50)
                    .typeString("technology")
                    .pauseFor(500)
                    .deleteChars(10)
                    .pauseFor(50)
                    .typeString("pricing")
                    .pauseFor(500)
                    .deleteChars(7)
                    .pauseFor(50)
                    .typeString("experience")
                    .pauseFor(500)
                    .deleteChars(10)
                    .pauseFor(50)
                    .typeString("Mortgage")
                    .pauseFor(2000)
                    .deleteChars(8)
                    .start()
                }}
              />
            )}
          </h1>
          <p className={styles.subhead}>
            <span className={styles.subheadLead}>
              Find out how much a better mortgage
            </span>{" "}
            might save you.
          </p>
        </div>
        <div className={styles.actions}>
          <SplashCtaDropdown />
        </div>
        <ScrollCta cta="Learn More" invertColor={true} />
      </div>
    </section>
  )
}

export default SplashHeroTypewriter
